module.exports = __webpack_public_path__ + "img/card-1.f6f4ac24.png";